import React from 'react'
import cx from 'classnames'
import styles from './modalHeader.module.scss'
import CloseIcon from '../../../../icons/closeIcon.svg'
import { useDispatch, useSelector } from 'react-redux'
import { closeConfirmationModal } from '../../../../redux/actions/confirmationModal'
import { setAdditionalEmail } from '../../../../redux/actions/quizQuestions'
import { setPdfEmail } from '../../../../redux/actions/pdfInputEmail'
import { setSignInWithEmailFormValidation } from '../../../../redux/actions/validation'
import emailValidator from '../../../../utils/validators/emailValidator'
import { useNavigate } from 'react-router-dom'

export default ({
  text,
  warning,
  stageCount,
  stage,
  handleCancel,
  headerBorder,
  modalFromSettings,
  hideCloseButton,
  checked,
}) => {
  const arr = new Array(stageCount).fill(stageCount)
  const {
    confirmationModal: { body },
  } = useSelector((state) => state)
  const { formEdit, formCopy } = useSelector((state) => state.quizQuestions)
  const dispatch = useDispatch()
  const { inputEmail } = useSelector((state) => state.pdfInputEmail)
  const navigate = useNavigate()
  return (
    <header
      className={cx(styles.headerStyles, {
        [styles.stages]: stageCount,
        [styles.hideCloseButton]: hideCloseButton,
        [styles.headerBorder]: headerBorder,
        [styles.modalFromSettings]: modalFromSettings,
      })}
    >
      {checked && <img className={styles.checkboxStyles} alt={'Select'} />}
      {warning ? (
        <div className={styles.reportHeader}>
          {/*<img src={ErrorIcon} alt={ErrorIcon} />*/}
          <span>{text}</span>
        </div>
      ) : stageCount ? (
        <div className={styles.stages}>
          {arr.map((item, index) => (
            <div
              className={cx(styles.stage, {
                [styles.disabledStage]: stage <= index,
              })}
              key={index}
            />
          ))}
        </div>
      ) : (
        <span>{text}</span>
      )}
      {!hideCloseButton && !formEdit && (
        <img
          src={CloseIcon}
          onClick={() => {
            ;(text === 'E-Mail hinzufügen' || text === 'E-Mail bearbeiten') &&
              !inputEmail &&
              dispatch(setSignInWithEmailFormValidation('emailErr', ''))
            inputEmail && dispatch(setPdfEmail(''))
            formCopy ? navigate('/profile') : dispatch(closeConfirmationModal())
            dispatch(closeConfirmationModal())
          }}
          alt={'Close'}
        />
      )}
    </header>
  )
}
